import React from "react";

export default function CloseIcon({ className, onClick }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      onClick={onClick}
      viewBox="0 0 24 24"
      className={`w-6 h-6 cursor-pointer ${className}`}
      strokeWidth={1.5}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
}
